const testConstantRouter = [
  {
    path: '/test',
    component: () => import('@/layout/LayoutIndex.vue'),
    hidden: true,
    children: [
      {
        path: '/test/testAddConstantRoutesAdd',
        component: () => import('@/views/test/testAddConstantRoutes/testAddConstantRoutesAdd.vue'),
        name: 'testAddConstantRoutesAdd',
        meta: { title: '测试菜单没有的页', requireAuth: false }
      },
      {
        path: '/purchases/MaterialDetail', // 访问路径
        component: () => import('@/views/TStockFlow/Model/MaterialDetail.vue'),
        name: 'MaterialDetail', // 组件名，建议与文件名一致
        meta: { title: '物料详情页面', requireAuth: false }
      },

    ]
  },
]

export default testConstantRouter;